import { addMonths, format } from 'date-fns';
import type { ExpirationValue } from './SeatExpirationCard';

/**
 * Calculate the actual expiration date based on the expiration value mode
 * @param expirationValue - The expiration configuration
 * @returns ISO datetime string at noon UTC (YYYY-MM-DDTHH:mm:ss.sssZ) or null if no expiration
 */
export function getExpirationDate(expirationValue: ExpirationValue): string | null {
  if (expirationValue.mode === 'no_end_date') {
    return null;
  }

  if (expirationValue.mode === 'specific_date') {
    // Convert YYYY-MM-DD to noon UTC to avoid timezone display issues
    const dateStr = expirationValue.specificDate?.trim();
    return dateStr ? `${dateStr}T12:00:00.000Z` : null;
  }

  if (expirationValue.mode === 'months_from_today') {
    const today = new Date();
    const expirationDate = addMonths(today, expirationValue.monthsFromToday);
    // Return ISO date string at noon UTC
    const dateStr = format(expirationDate, 'yyyy-MM-dd');
    return `${dateStr}T12:00:00.000Z`;
  }

  return null;
}
